import CollectionDetailPage from '../CollectionDetailPage';
export default function OutdoorPage() { return <CollectionDetailPage collectionId="outdoor" />; }
